import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { slide as Menu } from 'react-burger-menu';
import { NavbarBrand, ListGroup } from 'reactstrap';

import LogOutLink from '../LogOutLink';

import logo from '../../assets/logo.svg';
import logo_white from '../../assets/logo-white.svg';

import MenuLink from '../MenuLink';
import { menuStyles } from './styles';
import MenuSeparator from '../../pages/CompanyAdmin/components/MenuSeparator';

//HELPER
import { handleLogoNavigation } from '../../../src/containers/helper/appContainer';

//CONSTANTS
import { END_USERS_ROLE } from '../../utils/constants';
import closeIcon from '../../assets/close-icon.svg';
import { useStore } from '../../store';
import './styles.scss';
import useTheme from '../../theme/useTheme';

const Navbar = observer(({ history }) => {
  const {
    rootStore,
    rootStore: { profileStore },
  } = useStore();

  const { t } = useTranslation();

  const { theme } = useTheme();

  const [isOpen, setIsOpen] = useState(false);
  const isEndUser = rootStore.profileStore.connection === END_USERS_ROLE;
  const isCompanyAdmin = profileStore.isOwner && profileStore.companyAddress !== '';

  const setMenuState = isOpen => {
    setIsOpen(isOpen === true);
  };

  useEffect(() => {
    const handleRouteChange = () => {
      onRouteChanged();
    };

    history.listen(handleRouteChange);

    return () => {
      history.unlisten(handleRouteChange);
    };
    // eslint-disable-next-line
  }, [history]);

  const onRouteChanged = () => {
    setMenuState(false);
  };

  const isDarkMode =
    window.matchMedia('(prefers-color-scheme: dark)').matches || window.matchMedia('(color-scheme: dark)').matches;

  return (
    <div className="d-md-none styled-menu">
      <nav className="styled-nav navbar fixed-top navbar-expand-lg navbar-inverse">
        <NavbarBrand href={handleLogoNavigation(profileStore.connection)}>
          <img style={{ width: '113px' }} src={isDarkMode ? logo_white : logo} alt="Feller" />
        </NavbarBrand>
      </nav>
      <Menu
        isOpen={isOpen}
        styles={menuStyles(theme)}
        onStateChange={state => setMenuState(state.isOpen)}
        right
        customBurgerIcon={<span className="navbar-toggler-icon" />}
        customCrossIcon={<img className="navbar-cross-icon styled-close-icon" alt="Cross" src={closeIcon} />}
      >
        <ListGroup flush className="mobile-list-group mt-5">
          <MenuLink className="styled-mobile-menu-link" to="/welcome" exact isAllowed={!isEndUser}>
            {t('menu.welcome')}
          </MenuLink>
          <MenuLink className="styled-mobile-menu-link" to="/" isAllowed={true} exact>
            {t('menu.profile')}
          </MenuLink>
          <MenuLink className="styled-mobile-menu-link" to="/company" isAllowed={!isEndUser}>
            {t('menu.company')}
          </MenuLink>
          <MenuLink className="styled-mobile-menu-link" to="/account_settings" isAllowed={true}>
            {t('menu.accountSettings')}
          </MenuLink>
          <MenuLink className="styled-mobile-menu-link" to="/devices" isAllowed={isEndUser}>
            {t('menu.devices')}
          </MenuLink>
          <MenuLink className="styled-mobile-menu-link" to="/user_activities" isAllowed={isEndUser}>
            {t('menu.userActivities')}
          </MenuLink>
          <MenuLink className="styled-mobile-menu-link" to="/newsletters" isAllowed={true}>
            {t('menu.newsletters')}
          </MenuLink>
          <MenuLink className="styled-mobile-menu-link" to="/courses" isAllowed={!isEndUser}>
            {t('menu.courses')}
          </MenuLink>
          {isCompanyAdmin && <MenuSeparator isMobileMenu={true} />}
          <MenuLink className="styled-mobile-menu-link" to="/company_admin" isAllowed={isCompanyAdmin}>
            {t('menu.company_admin')}
          </MenuLink>
          <MenuLink className="styled-mobile-menu-link" to="/company_users" isAllowed={isCompanyAdmin}>
            {t('menu.company_admin_users')}
          </MenuLink>
        </ListGroup>
        {!profileStore.isNavigatedFromMobile && <LogOutLink rootStore={rootStore} isMobile />}
      </Menu>
    </div>
  );
});

export default withRouter(Navbar);
